import SalesInvoiceDetail from './SalesInvoiceDetail';

export default SalesInvoiceDetail;
